import { render } from "./ShipmentPackageContent.vue?vue&type=template&id=63e71c76&scoped=true"
import script from "./ShipmentPackageContent.vue?vue&type=script&lang=js"
export * from "./ShipmentPackageContent.vue?vue&type=script&lang=js"

import "./ShipmentPackageContent.vue?vue&type=style&index=0&id=63e71c76&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e71c76"]])

export default __exports__